var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Mixins } from 'vue-property-decorator';
import devToolMixin from '../../util/devToolMixin';
import EventPanel from './EventPanel';
import PayloadPanel from './PayloadPanel';
let TimelinePanel = class TimelinePanel extends Mixins(devToolMixin) {
  render() {
    const h = arguments[0];
    return h("a-row", {
      "class": "ucd-devTool-timeline"
    }, [h("a-col", {
      "attrs": {
        "span": 12
      },
      "style": "height:100%"
    }, [h(EventPanel)]), h("a-col", {
      "attrs": {
        "span": 12
      },
      "style": "height:100%"
    }, [h(PayloadPanel)])]);
  }
};
TimelinePanel = __decorate([Component({
  name: 'TimelinePanel'
})], TimelinePanel);
export default TimelinePanel;